import type { ButtonHTMLAttributes, HTMLAttributes, ReactNode, RefObject } from "react";

type NativeDialogProps = HTMLAttributes<HTMLDialogElement>;

import { useTranslation } from "../../core/translation.core";

interface DialogProps {
  title: string;
  message: ReactNode;
  dialogRef: RefObject<HTMLDialogElement>;
  confirm: () => void;
  cancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  children?: ReactNode;
  confirmButtonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  dialogProps?: NativeDialogProps;
}
export default function Dialog({
  title,
  message,
  dialogRef,
  confirm,
  cancel,
  confirmText,
  cancelText,
  children,
  confirmButtonProps,
  dialogProps,
}: DialogProps) {
  const { t, msg } = useTranslation();

  return (
    <dialog
      {...dialogProps}
      className={`p-4 dark:bg-her-backblue dark:text-white${dialogProps?.className ? ` ${dialogProps.className}` : ""}`}
      ref={dialogRef}
    >
      <h1 className="text-xl mb-4">{title}</h1>
      <p>{message}</p>
      {children}
      <div className="flex gap-2">
        <button
          {...confirmButtonProps}
          className="mt-4 border bg-blue-200 dark:bg-blue-800 px-2 py-1 rounded-sm dark:text-white"
          type="button"
          onClick={(e) => {
            confirmButtonProps?.onClick?.(e);
            confirm();
            dialogRef.current?.close();
          }}
        >
          {confirmText ? confirmText : t(msg.user.confirm)}
        </button>
        <button
          className="mt-4 border bg-gray-200  dark:bg-gray-800 px-2 py-1 rounded-sm dark:text-white"
          type="button"
          onClick={() => {
            cancel && cancel();
            dialogRef.current?.close();
          }}
        >
          {cancelText ? cancelText : t(msg.form.cancel)}
        </button>
      </div>
    </dialog>
  );
}
